module.exports = __webpack_public_path__ + "img/lift-net.da404c18.png";